// fp-theme.js
// Franchise Player — shared colors, labels and small helpers.
// Kept in its own file (not in FPApp.js) so the FP components can all import
// it without importing each other in a loop.

export const FP_ACCENT = "#14B8A6";
export const FP_ACCENT_LIGHT = "#5EEAD4";
export const FP_ACCENT_DARK = "#0F766E";
export const FP_ACCENT_DIM = "rgba(20,184,166,0.12)";

export const STATUS_LABELS = {
  shop_open: { label: "Captain shop open", color: FP_ACCENT },
  season_active: { label: "Season underway", color: "#00C853" },
  legacy: { label: "Old format", color: "#8892a4" },
};

// Status is derived from the shop deadline rather than stored.
export function leagueStatus(league) {
  if (!league?.shopDeadline) return "legacy";
  return league.shopDeadline.toMillis() > Date.now() ? "shop_open" : "season_active";
}

export function formatDeadline(ts) {
  if (!ts?.toDate) return "";
  return ts.toDate().toLocaleString(undefined, {
    weekday: "short", month: "short", day: "numeric", hour: "numeric", minute: "2-digit",
  });
}

export function timeUntil(ts) {
  if (!ts?.toMillis) return "";
  const ms = ts.toMillis() - Date.now();
  if (ms <= 0) return "closed";
  const days = Math.floor(ms / 86400000);
  const hours = Math.floor((ms % 86400000) / 3600000);
  const mins = Math.floor((ms % 3600000) / 60000);
  if (days > 0) return `${days}d ${hours}h`;
  if (hours > 0) return `${hours}h ${mins}m`;
  return `${mins}m`;
}

export const POSITION_COLORS = {
  QB: "#F87171",
  RB: "#34D399",
  WR: "#60A5FA",
  TE: "#FBBF24",
  DEF: "#C084FC",
  "D/ST": "#C084FC",
};

// An entry's display name (entries made before names existed fall back to "Entry N").
export function entryLabel(entry) {
  return (entry && entry.name) || `Entry ${entry?.entryNumber || 1}`;
}
